module.exports = __webpack_public_path__ + "static/media/Group_39@3x.5ba6fe94.png";